<template>
  <v-card class="pa-4 mb-4" outlined>
    <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
      <span>{{ tituloCard }}</span>
      <v-btn v-if="!readonly" small text color="primary" @click="adicionaLinha">
        <v-icon left small>mdi-plus</v-icon>{{ $t('contractV2.addRow') }}
      </v-btn>
    </v-card-title>
    <v-divider class="mb-3"></v-divider>

    <!-- Preço não linear da mão de obra: só em contrato de modelo FAIXAS. -->
    <v-card v-if="modeloMaoObra === 'FAIXAS'" outlined class="pa-3 mb-3">
      <div class="subtitle-2">{{ $t('contractV2.laborRangesTitle') }}</div>
      <div class="text-caption text--secondary mb-2">{{ $t('contractV2.laborRangesHint') }}</div>
      <v-row dense>
        <v-col v-for="r in regimeItems" :key="r.value" cols="12" sm="6" md="4">
          <v-text-field
            :value="faixasMaoObra[r.col]"
            :label="r.text"
            :suffix="'R$'"
            type="number"
            min="0"
            step="any"
            hide-spin-buttons
            dense
            :disabled="readonly"
            :rules="readonly ? [] : [(v) => v == null || v === '' || Number(v) >= 0 || $t('contractV2.row.nonNegative')]"
            :hint="$t('contractV2.laborPrice')"
            persistent-hint
            @input="emiteFaixas({ col: r.col, valor: $event })"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>

    <contrato-valor-linha
      v-for="(linha, idx) in linhas"
      :key="linha.uid"
      :value="linha"
      :tarifas-disponiveis="tarifasDisponiveis(linha)"
      :grandezas="grandezas"
      :calculos="calculos"
      :readonly="readonly"
      :can-criar-tarifa="canCriarTarifa"
      @input="atualizaLinha(idx, $event)"
      @remove="removeLinha(idx)"
      @criar-tarifa="$emit('criar-tarifa', { idTipoVeiculo: tipoVeiculo.id_tipo_veiculo, indice: idx, texto: $event })"
    />

    <div v-if="!linhas.length" class="text--secondary text-caption">
      {{ $t('contractV2.noRows') }}
    </div>
  </v-card>
</template>

<script>
import ContratoValorLinha from './ContratoValorLinha.vue';

/**
 * Card de um tipo de veículo do contrato. Reúne as linhas de valor daquele
 * tipo — as três clássicas (fixo, variável, mão de obra) e quantas mais o
 * usuário acrescentar.
 */
export default {
  name: 'ContratoTipoVeiculoCard',
  components: { ContratoValorLinha },
  props: {
    tipoVeiculo: { type: Object, required: true },
    linhas: { type: Array, default: () => [] },
    tarifas: { type: Array, default: () => [] },
    grandezas: { type: Array, default: () => [] },
    calculos: { type: Array, default: () => [] },
    modeloMaoObra: { type: String, default: 'PADRAO' },
    faixasMaoObra: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
    canCriarTarifa: { type: Boolean, default: false },
  },
  computed: {
    // Mesmo vocabulário do motor (COLUNA_POR_REGIME_MAO_OBRA, no backend).
    regimeItems() {
      return [
        ['MO_1MOT_1T_SEG_SAB', 'valor_mo_1mot_1t_seg_sab'],
        ['MO_1_5MOT_1T_30D', 'valor_mo_1_5mot_1t_30d'],
        ['MO_2MOT_2T_SEG_SAB', 'valor_mo_2mot_2t_seg_sab'],
        ['MO_2_5MOT_2T_30D', 'valor_mo_2_5mot_2t_30d'],
        ['MO_3MOT_3T_30D', 'valor_mo_3mot_3t_30d'],
      ].map(([value, col]) => ({
        value,
        col,
        text: this.$t('contractV2.laborRegime' + value),
      }));
    },
    tituloCard() {
      return this.tipoVeiculo.descricao_tipo_veiculo || this.$t('contractV2.vehicleType');
    },
  },
  methods: {
    /** Emite os preços das faixas: { faixas_mao_obra }. */
    emiteFaixas(mudanca) {
      const faixas = Object.assign({}, this.faixasMaoObra);
      faixas[mudanca.col] = mudanca.valor === '' || mudanca.valor == null ? null : Number(mudanca.valor);
      this.$emit('update:faixas', { faixas_mao_obra: faixas });
    },
    /**
     * Tarifas oferecidas na linha: as ainda não usadas neste card, mais a que a
     * própria linha já tem (senão o select abriria vazio ao editar).
     */
    tarifasDisponiveis(linha) {
      const usadas = new Set(
        this.linhas
          .filter((l) => l.uid !== linha.uid && l.id_tarifa != null)
          .map((l) => Number(l.id_tarifa)),
      );
      return (this.tarifas || []).filter((t) => !usadas.has(Number(t.id_tarifa)));
    },
    atualizaLinha(idx, linha) {
      const novas = this.linhas.slice();
      novas.splice(idx, 1, linha);
      this.$emit('update:linhas', novas);
    },
    removeLinha(idx) {
      const novas = this.linhas.slice();
      novas.splice(idx, 1);
      this.$emit('update:linhas', novas);
    },
    adicionaLinha() {
      this.$emit('add-linha', this.tipoVeiculo.id_tipo_veiculo);
    },
  },
};
</script>
